import { Dispatch, SetStateAction } from 'react';
import { Terminal } from './config';
import { SelectOption } from '@teko/ds-desktop';
import { CartPaymentMethod } from '@teko/cart/v2';

export interface KeyValuePair {
  [name: string]: string;
}

export interface SearchParams {
  [key: string]:
    | string
    | number
    | Array<string>
    | Array<number>
    | boolean
    | Array<boolean>;
}

export interface TimeFormat {
  dateTime: string | number | Date;
  timeFormat: string;
}

export interface ErrorMessageType {
  message: string;
  action: null | 'back_to_cart' | 'try_again';
}

export interface ErrorCouponType {
  couponCode: string;
  errorCode?: string;
  phone?: string;
  orderValueMin?: number | null;
  orderValueMax?: number | null;
}

export interface PolicyDisplayInfo {
  highlightText: string;
  iconUrl: string;
  isHighlighted: boolean;
  name: string;
  notes: string[];
}

export interface ProductPolicy {
  iconUrl?: string;
  name?: string;
  displayText?: string;
  detailUrl?: string;
  serviceGroupId?: number | null;
}

export interface FeedbackType {
  id: number;
  name: string;
}

export interface VatData {
  id: string;
  value: string;
  error: string;
  label: string;
  name: string;
  required?: boolean;
}

export enum OrderBy {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface CommonRegionPickerProps {
  showPopup: boolean;
  setShowPopup: (show: boolean) => void;
  terminals: Terminal[];
  selected: number;
  setSelected: Dispatch<SetStateAction<number>>;
  locationOptions: SelectOption[];
  onSubmitNewLocation: () => void;
  activeLocation?: Terminal;
  onOpenPopup: () => void;
  onClosePopup: () => void;
  useDropdownPicker: boolean;
  title: React.ReactNode;
  isShowLocationIcon?: boolean;
}

type JSONValue = { [k: string]: number | string | boolean | JSONObject };

export type JSONObject = string | number | boolean | JSONValue | JSONValue[];

export interface IMap<T> {
  [key: string]: T;
}

export interface InstallmentMethod extends CartPaymentMethod {
  bankCode?: string;
  totalItems: number;
  paymentTerm?: number;
  paymentMethod?: string;
  buyerName: string;
  buyerCity: string;
  buyerAddress: string;
  buyerIdentity?: string;
  amount?: number;
}

export enum DateFormat {
  YMD = 'yyyy-MM-dd',
}
